'use strict';

export default class Video {
  constructor() {

    $('.video-component__playbtn').fancybox({
        helpers : {
            media: true
        },
        youtube : {
            autoplay: 0
        }
    });
  }
}
